import React, { useEffect, useState } from 'react';
import MovieCard from '../Components/MovieCard';
import 'react-responsive-pagination/themes/classic.css';
import { useLocation } from 'react-router-dom';
import ScrollToTop from "react-scroll-to-top";
import Select from 'react-select';
import Loader from '../Components/Loader';
import Background from '../Components/Background';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import apiService from '../api/apiservice'; // Import apiService

const PopularPageTv = () => {
  const [loadingsaber, setLoadingsaber] = useState(true);
  const [value, setValue] = useState([]);
  const [tpage, Settpage] = useState(1);
  const [loading, setloading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterType, SetFilterType] = useState({ isTvChecked: true });
  const [genreOptions, setGenreOptions] = useState([]); // Renamed for clarity
  const [genreValue, SetgenreValue] = useState([]); // Store selected genre objects
  const [sort, setSort] = useState("popularity.desc");
  const location = useLocation();
  const [selectedOpt, SetselectedOpt] = useState(
    location?.state?.key ? [{ label: location.state.key.name, value: location.state.key.id }] : ""
  );
  const [genreIds, SetgenreIds] = useState(
    location?.state?.key?.id ? [location.state.key.id.toString()] : ''
  );

  const sortOptions = [
    { value: "popularity.desc", label: "By Popularity" },
    { value: "vote_count.desc", label: "Top Rated" },
    { value: "revenue.desc", label: "By Revenue" },
    { value: "name.asc", label: "By Name" }, // Adjusted for TV (title.asc -> name.asc)
    { value: "first_air_date.desc", label: "Newest Release" }, // Adjusted for TV (primary_release_date -> first_air_date)
  ];

  // Fetch genres and initial TV data
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // Fetch genres
        const genres = await apiService.getTVGenres();
        setGenreOptions(genres.map(g => ({ label: g.name, value: g.id.toString() })));

        // Fetch initial TV shows (page 1 and 2)
        setloading(true);
        const page1Data = await apiService.getTVByFilter(1, sort, genreIds);
        const page2Data = await apiService.getTVByFilter(2, sort, genreIds);
        setValue([...page1Data.results, ...page2Data.results]);
        Settpage(page2Data.total_pages);
        setCurrentPage(2); // Start at page 2 since we fetched 1 and 2
        setloading(false);

        // Stop initial loader after 1 second
        setTimeout(() => setLoadingsaber(false), 1000);
      } catch (error) {
        toast.error('PLOT TWIST !! Try Again Soon...');
        setloading(false);
        setLoadingsaber(false);
      }
    };

    fetchInitialData();
  }, [genreIds, sort]);

  // Infinite scroll fetch
  useEffect(() => {
    if (currentPage > 2) {
      setloading(true);
      setTimeout(async () => {
        try {
          const data = await apiService.getTVByFilter(currentPage, sort, genreIds);
          setValue(prev => [...prev, ...data.results]);
          setloading(false);
        } catch (error) {
          toast.error('PLOT TWIST !! Try Again Soon...');
          setloading(false);
        }
      }, 1000);
    }
  }, [currentPage, sort, genreIds]);

  // Infinite scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 1) {
        if (currentPage < tpage) {
          setCurrentPage(prev => prev + 1);
          setloading(true);
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [currentPage, tpage]);

  // Handle genre selection
  const handleCheckBoxChange = (selectedGenres) => {
    SetgenreValue(selectedGenres);
    SetgenreIds(selectedGenres.map(g => g.value).join(','));
    setCurrentPage(1); // Reset to page 1 on genre change
    setValue([]); // Clear current TV shows
  };

  // Handle sort selection
  const checkSelect = (selectedSort) => {
    setSort(selectedSort.value);
    setCurrentPage(1); // Reset to page 1 on sort change
    setValue([]); // Clear current TV shows
  };

  return (
    loadingsaber ? <><Loader /></> : <><div className='relative mt-20'>
      <div className='h-screen w-screen fixed top-0 z-10'></div>
      <ScrollToTop className="animate-bounce" smooth viewBox="0 0 20 20" color='#facc15' width='40px' style={{ backgroundColor: 'rgba(4,28,40,1)', zIndex: 50 }}
        svgPath='M13.889,11.611c-0.17,0.17-0.443,0.17-0.612,0l-3.189-3.187l-3.363,3.36c-0.171,0.171-0.441,0.171-0.612,0c-0.172-0.169-0.172-0.443,0-0.611l3.667-3.669c0.17-0.17,0.445-0.172,0.614,0l3.496,3.493C14.058,11.167,14.061,11.443,13.889,11.611 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.692-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.383,10c0-4.07-3.312-7.382-7.383-7.382S2.618,5.93,2.618,10S5.93,17.381,10,17.381S17.383,14.07,17.383,10' />

      <div className='relative md:flex md:flex-col z-40'>
        <div className='mt-4 flex flex-col md:flex-row justify-center items-center mb-2'>
          <Select
            theme={(theme) => ({
              ...theme,
              borderRadius: 10,
              colors: {
                ...theme.colors,
                primary25: 'rgb(250 204 21)',
                primary: '#fcd719',
                neutral0: 'rgb(55 65 81)',
                neutral80: 'white',
                neutral90: "rgb(100 100 100)",
              },
            })}
            className='newfont ml-4 md:w-[35%] z-50 w-[80%] mr-6 xl:text-[30px] font-normal text-white'
            onChange={checkSelect}
            placeholder="ORDER BY PREFERENCE"
            options={sortOptions}
            defaultValue={sortOptions.find(opt => opt.value === sort)}
          />

          <Select
            theme={(theme) => ({
              ...theme,
              borderRadius: 10,
              colors: {
                ...theme.colors,
                primary25: 'rgb(250 204 21)',
                primary: '#fcd719',
                neutral0: 'rgb(55 65 81)',
                neutral80: '#FFFFFF',
                neutral90: "rgb(255 255 255)",
                primary50: "#fcd719",
              },
            })}
            className='newfont ml-4 mt-3 md:mt-0 z-40 text-white mr-6 md:w-[35%] w-[80%] xl:text-[30px] font-normal'
            onChange={handleCheckBoxChange}
            options={genreOptions}
            placeholder="PICK YOUR VIBE"
            defaultValue={selectedOpt}
            isMulti
          />
        </div>

        <div className='h-full md:ml-[1rem] justify-center flex flex-wrap'>
          {value.length === 0 && genreIds ? loading ? <></> : <div className='z-20 newfont w-screen mt-10 text-gray-300 flex flex-col justify-center items-center'>
            <div className='md:text-7xl mob:text-2xl'>No Hits On This One 🫠</div>
            <div className='md:text-xl mt-4 text-xs text-center'>No matches found, Try a new search angle or different keywords</div>
          </div> : value.map((tv) => (
            <div className='mob:basis-[20.22%] md:basis-[8%] xl:basis-[12%]'><MovieCard movie={tv} filterType={filterType} /></div>
          ))}
          <div></div>
        </div>
      </div>

      {loading &&
        <div className='relative z-50 backdrop-filter backdrop-blur-sm'>
          <div className="rounded-md bottom-20 right-[50%] h-12 w-12 border-4 border-t-4 border-yellow-400 animate-spin absolute"></div>
        </div>
      }
      <Background />
      <ToastContainer />
    </div></>
  );
};

export default PopularPageTv;